<template>
  <div v-if="kontaktStore.loading">Loading...</div>
  <div v-else-if="kontaktStore.error">{{ kontaktStore.error }}</div>
  <ContactMap
    v-else
    title="Kontakti"
    :latitude="42.66191"
    :longitude="21.15908"
    :contactCards="kontaktStore.contactCards"
  />
</template>

<script>
import { onMounted } from "vue";


import{useKontaktStore} from "@/store/KontaktStore/kontaktStore";
import ContactMap from "@/components/share/ContactPerson.vue";

export default {
  components: { ContactMap },
  setup() {
    const kontaktStore = useKontaktStore();

    onMounted(() => {
      kontaktStore.getKontaktet();
    });

    return { kontaktStore };
  }
};
</script>
